var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewSecondary = function SvgNewSecondary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8h17v2a8 8 0 0 1-8 8H0V8Z",
    fill: "url(#new-secondary_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.664 8V2.4h1.072L9.04 6.432h-.52V2.4H9.8V8H8.736L5.424 3.968h.52V8h-1.28Zm8.349.064c-.49 0-.923-.096-1.296-.288a2.14 2.14 0 0 1-.856-.784 2.172 2.172 0 0 1-.304-1.144c0-.432.099-.813.296-1.144.203-.336.477-.597.824-.784a2.386 2.386 0 0 1 1.176-.288c.421 0 .8.09 1.136.272.341.176.61.432.808.768.197.33.296.728.296 1.192 0 .048-.003.104-.008.168l-.016.168h-3.496v-.728h2.84l-.48.216c0-.224-.045-.419-.136-.584a.965.965 0 0 0-.376-.384 1.067 1.067 0 0 0-.56-.144 1.11 1.11 0 0 0-.568.144.953.953 0 0 0-.376.392c-.09.165-.136.363-.136.592v.192c0 .235.05.443.152.624.107.176.253.312.44.408.192.09.416.136.672.136a1.46 1.46 0 0 0 1.08-.416l.664.72a1.972 1.972 0 0 1-.744.52 2.808 2.808 0 0 1-1.032.176ZM16.67 8l-1.552-4.304h1.176L17.582 7.4h-.56l1.344-3.704h1.056L20.726 7.4h-.56l1.328-3.704h1.104L21.038 8H19.83l-1.144-3.176h.368L17.87 8h-1.2Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "new-secondary_svg__a",
    x1: 30.833,
    y1: 1.667,
    x2: 2.592,
    y2: 15.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#FFB5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B91D73"
  })))));
};
export default SvgNewSecondary;